'use es6';

/* Sub header filters */
export const SEARCH = 'filterSearch';
export const OWNED_BY = 'filterOwnedById';
export const DASHBOARD_ID = 'filterDashboardId';
export const UPDATED_AT = 'filterUpdatedAt';
export const LAST_VIEWED_AT = 'filterLastViewedAt';
export const ASSIGNED = 'filterAssigned';
export const BUSINESS_UNIT = 'filterBusinessUnit';

/* Sidebar filters */
export const IN_DASHBOARD = 'filterInDashboard';
export const CUSTOM_REPORTS = 'filterCustomReports';
export const FAVORITES = 'filterFavorites';
export const UNUSED = 'filterUnused';

/* Filter values */
export const ALL_TIME = 'ALL_TIME';
export const CUSTOM = 'CUSTOM';